import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b52ad3fe")

_pushScopeId("data-v-b52ad3fe")
const _hoisted_1 = { class: "tabs" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("ul", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, index) => {
      return (_openBlock(), _createBlock("li", {
        key: tab && tab.value || tab,
        class: ['wt-tab-nav', { active: index === _ctx.current}],
        onClick: ($event: any) => (_ctx.change(index))
      }, [
        _renderSlot(_ctx.$slots, "default", { tab: tab }, () => [
          _createTextVNode(_toDisplayString(tab && tab.label || tab), 1)
        ], true)
      ], 10, ["onClick"]))
    }), 128))
  ]))
})